import { useEffect, useRef, useState } from "react";
import { snakeRecord } from "@/modes";
import { RecordName } from "@/RecordName";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/snake`;

const useWorldRecord = (now) => {
  const [world, setWorld] = useState({ length: 0, name: "" });
  const [token, setToken] = useState(null);
  const sent = useRef(0);
  const tokenRef = useRef(null);
  const send = (length) => {
    sent.current = length;
    fetch(`${API}/record`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ length, token: tokenRef.current }) })
      .then((r) => r.json()).then((j) => { setWorld({ length: j.length || length, name: j.name || "" }); if (j.token) { tokenRef.current = j.token; setToken(j.token); } })
      .catch(() => {});
  };
  useEffect(() => {
    const load = () => fetch(`${API}/record`).then((r) => r.json()).then((j) => setWorld((w) => ({ length: j.length || 0, name: j.name || "" }))).catch(() => {});
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    if (now <= world.length || now <= sent.current) return;
    const t = setTimeout(() => send(now), 1200);
    return () => clearTimeout(t);
  }, [now, world.length]);
  useEffect(() => () => {
    const best = window.__snakeLength || 0;
    if (best > sent.current) navigator.sendBeacon?.(`${API}/record`, new Blob([JSON.stringify({ length: best, token: tokenRef.current })], { type: "application/json" }));
  }, []);
  useEffect(() => {
    const onCrash = () => { const best = window.__snakeLastLength || 0; if (best > sent.current) send(best); };
    window.addEventListener("snake-crash", onCrash);
    return () => window.removeEventListener("snake-crash", onCrash);
  }, []);
  const holder = token && sent.current >= world.length;
  return { length: Math.max(world.length, now), name: now > world.length && !holder ? "" : world.name, token: holder ? token : null, setWorld };
};

export const SnakeScore = () => {
  const [now, setNow] = useState(0);
  const [record, setRecord] = useState(snakeRecord);
  const [fresh, setFresh] = useState(false);
  const world = useWorldRecord(now);

  useEffect(() => {
    const id = setInterval(() => setNow(window.__snakeLength || 0), 250);
    let t;
    const onRecord = () => {
      setRecord(snakeRecord());
      setFresh(true);
      clearTimeout(t);
      t = setTimeout(() => setFresh(false), 2500);
    };
    window.addEventListener("snake-record", onRecord);
    return () => { clearInterval(id); clearTimeout(t); window.removeEventListener("snake-record", onRecord); };
  }, []);

  return (
    <div className="snake-score" data-fresh={fresh} data-testid="snake-score">
      <span className="ss-label">length</span>
      <span className="ss-num" data-testid="snake-length">{now}</span>
      <span className="ss-sep" />
      <span className="ss-label">{fresh ? "new record!" : "record"}</span>
      <span className="ss-num ss-record" data-testid="snake-record">{record}</span>
      <span className="ss-sep" />
      <span className="ss-label">world best</span>
      <span className="ss-num ss-world" data-testid="snake-world-record">{world.length}</span>
      {world.name && <span className="ss-holder" data-testid="snake-world-name">{world.name}</span>}
      {world.token && <RecordName api={API} token={world.token} current={world.name} onSaved={world.setWorld} />}
    </div>
  );
};

export const ScaryFlash = () => {
  const [hit, setHit] = useState(0);
  useEffect(() => {
    let t;
    const on = () => {
      setHit((h) => h + 1);
      clearTimeout(t);
      t = setTimeout(() => setHit(0), 1600);
    };
    window.addEventListener("scary-flash", on);
    return () => { clearTimeout(t); window.removeEventListener("scary-flash", on); };
  }, []);
  return hit ? <div key={hit} className="scary-flash" data-testid="scary-flash" aria-hidden="true" /> : null;
};
